<template>
  <div
    class="block-wrap block-specification-list"
    style="padding-top: 8px">
    <div class="sku-batch-row">
      <template v-for="(sname, sindex) in specificationNames">
        <div
          class="sku-batch-item"
          v-if="sname.name"
          :key="sname.name + sindex">
          <div class="sku-batch-item_label">{{sname.name}}：</div>
          <el-select
            style="width: 180px"
            placeholder="全部"
            multiple
            collapse-tags
            :clearable="true"
            v-model="skuBatchUpdateForm[sindex]"
            @change="getRenderList"
            >
            <el-option
              v-for="(item, vindex) in specifications[sindex].values"
              :key="sname.name + sindex + vindex + item.value"
              :label="displayValueMaps[item.value]"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </template>
      <el-button type="link" @click="resetFilter" class="sku-batch-item"> 重置筛选条件 </el-button>
    </div>
    <div class="sku-batch-row">
      <div
        v-for="(name, key) in skuBatchUpdateLabels"
        :key="key"
        class="sku-batch-item">
        <div class="sku-batch-item_label">{{name.label}}：</div>
        
        <el-input-digit
          v-if="name.input.type === 'number'"
          v-model.number="skuBatchUpdateForm[key]"
          style="width: 120px;"
          :nullable="true"
          v-bind="name.input.attrs"
        >
          <template v-if="name.input.attrs && name.input.attrs.append">
            <el-select
              v-if="name.input.attrs.append.includes('|')"
              v-model="skuBatchUpdateForm[`${key}_unit`]"
              style="width: 60px;right: -5px;"
            >
              <el-option v-for="unit in name.input.attrs.append.split('|')" :key="unit" :value="unit" :label="unit" />
            </el-select>
            <span v-else> {{name.input.attrs.append}}</span>
          </template>
        </el-input-digit>
        <el-date-picker
          v-else-if="name.input.type === 'date'"
          v-model="skuBatchUpdateForm[key]"
          v-bind="name.input.attrs"
          ></el-date-picker>
        <el-select
          v-else-if="name.input.type === 'select'"
          v-model="skuBatchUpdateForm[key]"
          v-bind="name.input.attrs"
          style="width: 80px;"
        >
          <template v-for="(item, index) in name.input.options">
            <el-option :key="index" :value="item.value" :label="item.displayName" />
          </template>
        </el-select>
        <el-input
          v-else
          v-model="skuBatchUpdateForm[key]"
          style="width: 120px;"
          v-bind="name.input.attrs">
          <template v-if="name.input.attrs && name.input.attrs.append" slot="append">
            <el-select
              v-if="name.input.attrs.append.includes('|')"
              v-model="skuBatchUpdateForm[`${key}_unit`]"
              style="width: 60px;"
            >
              <el-option v-for="unit in name.input.attrs.append.split('|')" :key="unit" :value="unit" :label="unit" />
            </el-select>
            <span v-else> {{name.input.attrs.append}}</span>
          </template>
        </el-input>

      </div>
      <div class="sku-batch-item">
        <el-button @click="skuBatch">批量设置</el-button>
        <slot name="skuBatchSlot"></slot>
        <template v-for="(item, index) in batchSetBtns">
          <el-dropdown v-if="item.subBtns && item.subBtns.length" :key="index" trigger="hover" @command="handleCommandBatchSet" style="margin-left: 10px;">
            <el-button> {{ item.title }}<i class="el-icon-arrow-down el-icon--right"></i> </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(subItem, subIndex) in item.subBtns" :key="subIndex" :command="subItem.command" :disabled="item.disabled">
                {{ subItem.label }}
                <el-tooltip v-if="subItem.tooltip" class="item" :content="subItem.tooltip" popper-width="190px" placement="top">
                  <i class="el-icon-question" style="line-height: 28px;margin-left: 5px;" />
                </el-tooltip>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span v-else :key="index" style="margin-left: 10px;">
            <el-button @click="handleCommandBatchSet(item.command)" :disabled="item.disabled">{{ item.label }}</el-button>
            <el-tooltip v-if="item.tooltip" class="item" :content="item.tooltip" popper-width="190px" placement="top">
              <i class="el-icon-question" style="line-height: 28px;margin-left: 5px;" />
            </el-tooltip>
          </span>
        </template>
      </div>
    </div>

    <el-table-grid
      :height="computedHeight"
      :span-method="arraySpanMethod"
      :data="renderList"
      :row-height="70"
      @selection-change="handleSelectionChange"
      v-on="$listeners"
    >
      <el-table-column width="60px" type="selection"></el-table-column>
      <template v-for="(item,index) in specificationNames">
        <el-table-column
          :key="specifications[index].name + index"
          :label="specifications[index].name"
          v-if="item.name"
          width="100">
          <template slot-scope="{row}">
            {{row[skuSpecificationsKey][index] && row[skuSpecificationsKey][index]._displayValue}}
          </template>a
        </el-table-column>
      </template>
      <el-table-column
        prop="imageUrl"
        label="预览图"
        :grid-overflow-tooltip="false"
        width="100">
        <template slot-scope="{row}">
          <div style="margin: 14px 0px 5px;">
            <ImgUpload
              :width="46"
              :height="46"
              :onlyPreview="imgOnlyPreview"
              :file="row[skuSpecificationsKey][0] ? row[skuSpecificationsKey][0].imageUrl : ''"
              @upload-success="(url) => row[skuSpecificationsKey][0].imageUrl = url"
              @del="() => row[skuSpecificationsKey][0].imageUrl = ''"
              :isSingle="true"
              :limitSuffix="imgLimitSuffix"
              :uploadFunc="uploadFunc"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(col, colindex) in tableCols"
        :key="col.prop"
        :prop="col.prop"
        v-bind="{...col.attrs,'header-tooltip':null}"
      >
        <template slot="header">
          <template v-if="col.headerSlot">
            <slot :name="col.prop + 'HeaderSlot'"></slot>
          </template>
          <template v-else>
            <span v-if="!col.attrs.noRequired" style="color: red">*</span>{{col.attrs.label}}
            <el-tooltip placement="top" v-if="col.attrs['header-tooltip']">
              <div slot="content" v-html="col.attrs['header-tooltip']"></div>
              <i style="margin-left: 5px; margin-right: 5px;" class="el-icon-question" />
            </el-tooltip>
          </template>
        </template>
        <template slot-scope="{row, $index}">
          <div v-if="row.isGray && colindex === 0" style="background: #eee; height: 60px; width: 100%; padding: 20px;">铺货时系统自动补全</div>
          <template v-else-if="col.input">
            <el-form-item
              :error="row[`error_${col.prop}`]"
              style="margin-bottom: 18px;"
            >
              <slot v-if="col.slot" :name="col.prop + 'Slot'" v-bind="{row, $index}"></slot>
              <template v-else-if="col.input.type === 'number'">
                  <el-input-digit
                    v-model.number="row[col.prop]"
                    :nullable="true"
                    v-bind="col.input.attrs"
                    :disabled="col.disabledFn ? col.disabledFn(row) : !row['skuOuterId']"
                    @input="onInput(row, col.prop)"
                  >
                    <template v-if="col.input.attrs &&col.input.attrs.append">
                      <el-select
                        v-if="col.input.attrs.append.includes('|')"
                        v-model="row[`${col.prop}_unit`]"
                        style="width: 60px;right: -5px;"
                        @change="onChange(row, `${col.prop}_unit`)"
                      >
                        <el-option v-for="unit in col.input.attrs.append.split('|')" :key="unit" :value="unit" :label="unit" />
                      </el-select>
                      <span v-else> {{col.input.attrs.append}}</span>
                    </template>
                  </el-input-digit>
              </template>
              <el-input
                v-else-if="col.input.type === 'text'"
                v-model="row[col.prop]"
                @input="onInput(row, col.prop)"
                v-bind="col.input.attrs"
                :disabled="col.disabledFn ? col.disabledFn(row) : !row['skuOuterId']">
                 <template v-if="col.input.attrs && col.input.attrs.append" slot="append">
                  <el-select
                    v-if="col.input.attrs.append.includes('|')"
                    v-model="row[`${col.prop}_unit`]"
                    style="width: 60px;"
                    @change="onChange(row, `${col.prop}_unit`)"
                  >
                    <el-option v-for="unit in col.input.attrs.append.split('|')" :key="unit" :value="unit" :label="unit" />
                  </el-select>
                  <span v-else> {{col.input.attrs.append}}</span>
                </template>
              </el-input>
              <el-date-picker
                v-else-if="col.input.type === 'date'"
                v-model="row[col.prop]"
                @input="onInput(row, col.prop)"
                :disabled="col.disabledFn ? col.disabledFn(row) : !row['skuOuterId']"
                v-bind="col.input.attrs"
                ></el-date-picker>
              <Select2
                v-else-if="col.input.type === 'select'"
                v-model="row[col.prop]"
                @change="onChange(row, col.prop)"
                :disabled="col.disabledFn ? col.disabledFn(row) : !row['skuOuterId']"
                labelKey="displayName"
                :options="col.input.options"
                v-bind="col.input.attrs"
              >
                <!-- <template v-for="(item, index) in col.input.options">
                  <el-option :key="index" :value="item.value" :label="item.displayName" />
                </template> -->
              </Select2>
              <span v-else>{{row[col.prop]}}</span>
            </el-form-item>
          </template>
          <template v-else-if="col.prop=='skuOuterId'">
            <span v-if="row['skuOuterId']">{{ row['skuOuterId'] }}</span>
            <span v-else style="color: red;">请在基础资料维护信息</span>
          </template>
          <template v-else>
            {{col.format ? col.format(row) : row[col.prop]}}
          </template>
        </template>
      </el-table-column>
    </el-table-grid>

  </div>
</template>

<script>
import ImgUpload from '@/components/Uploads/ImgUpload'
import Select2 from '../../Select/index2.vue'
import { cloneDeep } from 'lodash';

export default {
  model: {
    prop: "list",
    event: 'change'
  },
  components: {
    ImgUpload,
    Select2
  },
  props: {
    displayValueMaps: {
      type: Object,
      default() {
        return {}
      }
    },
    list: {
      type: Array,
      default() {
        return []
      }
    },
    specifications: {
      type: Array,
      default() {
        return []
      }
    },
    skuSpecificationsKey: {
      type: String,
      default: 'skuSpecifications'
    },
    tableCols: {
      type: Array,
      default() {
        return []
      }
    },
    imgLimitSuffix: { // 图片类型限制
      type: String,
      default: '.jpg,.jpeg,.png,.gif'
    },
    imgOnlyPreview: { // 图片是否只能预览
      type: Boolean,
      default: true
    },
    uploadFunc: {
      type: Function
    },
    outerId: { // 商品款式编码
      type: String,
      default: ''
    },
    // 是否需要Selection操作列
    multipleSelection: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      skuBatchUpdateForm: {},
      valueForm: {},
      renderList: [],
      isRenderListChange: false,
      selectList:[]
    }
  },
  computed: {
    specificationNames() {
      return this.specifications.map(item => ({name: item.name}))
    },
    skuBatchUpdateLabels() {
      let labels = {}
      this.tableCols.forEach(item => {
        if (item.input && !item.input.onlyTable) {
          labels[item.prop] = {label: item.attrs.label, input: item.input}
        }
      })
      return labels
    },
    computedValueForm() {
      let form = {}
      this.tableCols.forEach(item => {
        if (item.input) {
          form[item.prop] = ''
        }
      })
      return form
    },
    batchSetBtns() {
      let btns = [
        {
          title: '批量操作平台规格编码',
          subBtns: [
            { label: '按基础资料商品编码填充', command: 'fillSkuOuterId', visible: true},
            { label: '清空平台规格编码', command: 'clearSkuOuterId', visible: true },
          ]
        }
      ]
      return btns.filter(item => {
        if(item.subBtns?.length) {
          item.subBtns = item.subBtns.filter(subItem => subItem.visible)
          return item.subBtns.length
        } 
        return item.visible
      })
    },
    computedHeight() {
      return '300px'
    }
  },
  watch: {
    list: {
      handler(ls) {
        if(this.isRenderListChange) {
          setTimeout(() => {
              this.isRenderListChange = false
          }, 500);
          return
        }
        this.renderList = cloneDeep(ls)
      },
      immediate: true,
      deep: true
    },
    renderList: {
      handler(ls) {
        const list = cloneDeep(this.list)
        ls.forEach(renderItem => {
          const findIndex = this.list.findIndex(item => item._skuid === renderItem._skuid)
          list.splice(findIndex, 1, cloneDeep(renderItem))
        })
        this.isRenderListChange = true
        this.$emit('change', list);
      },
      deep: true
    },
  },
  methods: {
    getRenderList() {
      this.renderList = this.list.filter((item) => {
        const _c_arr = item[this.skuSpecificationsKey].map(item => item.value);
        const matched = _c_arr.every((c, cindex) => !this.skuBatchUpdateForm[cindex]?.length || this.skuBatchUpdateForm[cindex].includes(c));
        return matched;
      });
    },
    resetFilter() {
      Object.keys(this.skuBatchUpdateForm).forEach(key => {
        this.skuBatchUpdateForm[key] = ''
      })
      this.getRenderList()
    },
    handleSelectionChange(select) {
      this.selectList = select
    },
    initSkuBatchUpdateForm() {
      const spNamesForm = {}
      this.specificationNames.forEach((item,index) => {spNamesForm[index] = ''})

      this.skuBatchUpdateForm = {
        ...spNamesForm,
        ...JSON.parse(JSON.stringify(this.computedValueForm))
      }
    },
    // 批量设置
    skuBatch() {
      // 批量设置中有一项填了值就设置
      const hasVal = Object.keys(this.skuBatchUpdateLabels).find(key => this.skuBatchUpdateForm[key] || this.skuBatchUpdateForm[key] === 0)
      if (!hasVal) return;
      const selectList = this.selectList.length ? this.selectList : this.renderList
      this.renderList.map(item => {
        const someItem = selectList.some(selectItem => selectItem._skuid === item._skuid)
        if(someItem) {
          Object.keys(this.skuBatchUpdateLabels).forEach((key) => {
            if (this.skuBatchUpdateForm[key] === 0) {
              this.$set(item, key, 0)
              return;
            }
            if (this.skuBatchUpdateForm[key]) {
              this.$set(item, key, this.skuBatchUpdateForm[key] || item[key] || "")
              if(this.skuBatchUpdateForm[`${key}_unit`]) {
                this.$set(item, `${key}_unit`, this.skuBatchUpdateForm[`${key}_unit`] || "")
              }
            }
          });
        }
      })
    },
    getNeedBatchList() {
      return this.selectList.length ? this.selectList : this.renderList;
    },
    handleCommandBatchSet(command) {
      const selectList = this.getNeedBatchList();
      if (selectList.length === 0) {
        this.$message.error('请选择需要批量修改的SKU');
        return;
      }
      if(['fillSkuOuterId', 'clearSkuOuterId'].includes(command)) {
        let platformSkuOuterIdKey = 'outSkuPlatform'
        let baseSkuOuterIdKey = 'sku_outerId'
        this.batchUpdateRenderListSkuOuterId(platformSkuOuterIdKey, baseSkuOuterIdKey, selectList, command === 'clearSkuOuterId')
      }
    },
    batchUpdateRenderListSkuOuterId(platformSkuOuterIdKey, baseSkuOuterIdKey, batchList, isClear) {
      const targetSkuIds = new Set(batchList.map(item => item._skuid));
       this.renderList.forEach(item => {
        if (targetSkuIds.has(item._skuid)) {
          this.$set(item, platformSkuOuterIdKey, isClear ? '' : item[baseSkuOuterIdKey])
        }
      });
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if(row.isGray && columnIndex == this.specificationNames.length + 2) {
        return [1, this.tableCols.length + 1]
      } else if(row.isGray && columnIndex > this.specificationNames.length + 2) {
        return [1, undefined]
      }
      return [1, 1]
    },
    changeListItem(index,key,val){
      if(val){
        this.$set(this.renderList[index], key, val)
      }else{
        this.$delete(this.renderList[index], key)
      }
    },
    onInput(row, field) {
      if(!row.skuOuterId) return
      this.$set(row, field, row[field])
      this.$emit('inputChange', row, field);
    },
    onChange(row, field) {
      if(!row.skuOuterId) return
      this.$set(row, field, row[field])
      this.$emit('inputChange', row, field);
    }
  },
  mounted() {
    this.initSkuBatchUpdateForm()
  }
}
</script>

<style lang="scss" scoped>
.block-wrap {
  border: 1px solid #DCDFE6;
}
.sku-batch-row {
  display: flex;
  flex-wrap: wrap;
  .sku-batch-item {
    display: flex;
    margin-bottom: 8px;
    margin-right: 8px;
    .sku-batch-item_label {
      width: 100px;
      text-align: right;
    }
  }
  ::v-deep .el-date-editor--date {
    width: 110px !important;
  }
}
.block-specification-list {
  // max-height: 400px;
  // overflow-y: auto;
  ::v-deep .pdd-cell .cell {
    overflow: visible;
    padding: 5px
  }
}
</style>